var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _clipPath66, _clipPath67, _clipPath68, _clipPath69, _clipPath70, _clipPath71, _clipPath72, _clipPath73, _clipPath74, _clipPath75, _clipPath76, _clipPath77, _clipPath78, _clipPath79, _clipPath80, _clipPath81, _clipPath82, _clipPath83, _clipPath84, _clipPath85, _clipPath86, _clipPath87, _clipPath88, _clipPath89, _clipPath90, _clipPath91, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarberiaClubLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.811765,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,25.882353%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 69.800781 45 C 69.4375 44.714844 69.304688 44.316406 69.398438 43.800781 C 67.628906 43.691406 65.894531 43.824219 64.199219 44.199219 C 65.886719 43.425781 67.753906 43.160156 69.800781 43.398438 C 69.800781 43.933594 69.800781 44.46875 69.800781 45 Z M 69.800781 45 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.815686,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 159.800781 44.199219 C 157.933594 43.667969 156.066406 43.667969 154.199219 44.199219 C 154.957031 43.679688 155.890625 43.410156 157 43.398438 C 158.109375 43.410156 159.042969 43.679688 159.800781 44.199219 Z M 159.800781 44.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.709804,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.411765%,29.411765%,29.411765%)",
      fillOpacity: 1
    },
    d: "M 88.199219 43.800781 C 84.867188 43.800781 81.53125 43.800781 78.199219 43.800781 C 78.199219 51.800781 78.199219 59.800781 78.199219 67.800781 C 77.800781 59.734375 77.667969 51.601562 77.800781 43.398438 C 81.339844 43.269531 84.804688 43.402344 88.199219 43.800781 Z M 88.199219 43.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.705882,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(28.627451%,28.627451%,28.627451%)",
      fillOpacity: 1
    },
    d: "M 122.199219 47.398438 C 122.066406 47.398438 121.933594 47.398438 121.800781 47.398438 C 121.800781 46.199219 121.800781 45 121.800781 43.800781 C 117.933594 43.800781 114.066406 43.800781 110.199219 43.800781 C 110.199219 51.800781 110.199219 59.800781 110.199219 67.800781 C 109.800781 59.734375 109.667969 51.601562 109.800781 43.398438 C 113.933594 43.398438 118.066406 43.398438 122.199219 43.398438 C 122.199219 44.734375 122.199219 46.066406 122.199219 47.398438 Z M 122.199219 47.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.619608,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.980392%,50.980392%,50.980392%)",
      fillOpacity: 1
    },
    d: "M 105 44.199219 C 105.5625 44.390625 105.828125 44.789062 105.800781 45.398438 C 105.238281 45.210938 104.972656 44.8125 105 44.199219 Z M 105 44.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.941176,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.784314%,40.784314%,40.784314%)",
      fillOpacity: 1
    },
    d: "M 69.800781 45 C 70.363281 46.085938 70.632812 47.289062 70.601562 48.601562 C 70.035156 47.511719 69.769531 46.3125 69.800781 45 Z M 69.800781 45 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.647059,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(45.098039%,45.098039%,45.098039%)",
      fillOpacity: 1
    },
    d: "M 85.800781 47.800781 C 84.601562 47.800781 83.398438 47.800781 82.199219 47.800781 C 82.199219 50.332031 82.199219 52.867188 82.199219 55.398438 C 83.398438 55.398438 84.601562 55.398438 85.800781 55.398438 C 84.550781 55.792969 83.21875 55.925781 81.800781 55.800781 C 81.800781 53 81.800781 50.199219 81.800781 47.398438 C 83.21875 47.273438 84.550781 47.410156 85.800781 47.800781 Z M 85.800781 47.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.403922,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.607843%,59.607843%,59.607843%)",
      fillOpacity: 1
    },
    d: "M 121.800781 47.398438 C 121.933594 47.398438 122.066406 47.398438 122.199219 47.398438 C 119.609375 47.796875 116.941406 47.929688 114.199219 47.800781 C 114.199219 49.667969 114.199219 51.53125 114.199219 53.398438 C 116.277344 53.273438 118.277344 53.40625 120.199219 53.800781 C 118.066406 53.800781 115.933594 53.800781 113.800781 53.800781 C 113.800781 51.667969 113.800781 49.53125 113.800781 47.398438 C 116.46875 47.398438 119.132812 47.398438 121.800781 47.398438 Z M 121.800781 47.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.133333,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.647059%,77.647059%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 133.398438 47.800781 C 132.332031 47.800781 131.265625 47.800781 130.199219 47.800781 C 130.199219 50.332031 130.199219 52.867188 130.199219 55.398438 C 131.265625 55.398438 132.332031 55.398438 133.398438 55.398438 C 132.285156 55.789062 131.085938 55.925781 129.800781 55.800781 C 129.800781 53 129.800781 50.199219 129.800781 47.398438 C 131.085938 47.277344 132.285156 47.410156 133.398438 47.800781 Z M 133.398438 47.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.211765,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,71.372549%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 101.800781 47.800781 C 100.734375 47.800781 99.667969 47.800781 98.601562 47.800781 C 98.601562 49.667969 98.601562 51.53125 98.601562 53.398438 C 99.667969 53.398438 100.734375 53.398438 101.800781 53.398438 C 100.683594 53.789062 99.484375 53.925781 98.199219 53.800781 C 98.199219 51.667969 98.199219 49.53125 98.199219 47.398438 C 99.484375 47.277344 100.683594 47.410156 101.800781 47.800781 Z M 101.800781 47.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0666667,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.058824%,87.058824%,87.058824%)",
      fillOpacity: 1
    },
    d: "M 51.398438 47.800781 C 51.664062 48.65625 51.796875 49.589844 51.800781 50.601562 C 51.789062 51.707031 51.523438 52.640625 51 53.398438 C 51.375 51.570312 51.507812 49.707031 51.398438 47.800781 Z M 51.398438 47.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0392157,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,71.372549%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 67.398438 51.800781 C 67.132812 51.398438 66.867188 51 66.601562 50.601562 C 66.539062 50.050781 66.605469 49.515625 66.800781 49 C 67.28125 49.871094 67.480469 50.804688 67.398438 51.800781 Z M 67.398438 51.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.290196,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.490196%,65.490196%,65.490196%)",
      fillOpacity: 1
    },
    d: "M 133.398438 47.800781 C 133.925781 48.902344 134.195312 50.167969 134.199219 51.601562 C 134.195312 53.03125 133.925781 54.296875 133.398438 55.398438 C 133.933594 52.867188 133.933594 50.332031 133.398438 47.800781 Z M 133.398438 47.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0705882,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(73.333333%,73.333333%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 157.398438 51 C 157.132812 51 156.867188 51 156.601562 51 C 156.867188 48.867188 157.132812 48.867188 157.398438 51 Z M 157.398438 51 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.623529,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,47.45098%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 71 50.601562 C 71.507812 51.5625 71.773438 52.628906 71.800781 53.800781 C 71.183594 52.863281 70.917969 51.796875 71 50.601562 Z M 71 50.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.54902,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.470588%,56.470588%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 105.398438 55.800781 C 105.960938 55.988281 106.230469 56.390625 106.199219 57 C 105.636719 56.8125 105.371094 56.410156 105.398438 55.800781 Z M 105.398438 55.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.580392,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.627451%,68.627451%,68.627451%)",
      fillOpacity: 1
    },
    d: "M 101.398438 57.800781 C 101.933594 57.800781 102.199219 58.066406 102.199219 58.601562 C 101.800781 58.46875 101.53125 58.199219 101.398438 57.800781 Z M 101.398438 57.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0666667,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,86.27451%,86.27451%)",
      fillOpacity: 1
    },
    d: "M 51 57.800781 C 51.523438 58.558594 51.789062 59.492188 51.800781 60.601562 C 51.796875 61.609375 51.664062 62.542969 51.398438 63.398438 C 51.507812 61.496094 51.375 59.628906 51 57.800781 Z M 51 57.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.192157,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(73.72549%,73.72549%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 89 59 C 88.757812 59.355469 88.621094 59.757812 88.601562 60.199219 C 88.046875 59.621094 88.179688 59.222656 89 59 Z M 89 59 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.403922,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.705882%,64.705882%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 120.199219 57.398438 C 118.277344 57.792969 116.277344 57.929688 114.199219 57.800781 C 114.199219 59.667969 114.199219 61.53125 114.199219 63.398438 C 116.808594 63.269531 119.34375 63.402344 121.800781 63.800781 C 119.132812 63.800781 116.46875 63.800781 113.800781 63.800781 C 113.800781 61.667969 113.800781 59.53125 113.800781 57.398438 C 115.933594 57.398438 118.066406 57.398438 120.199219 57.398438 Z M 120.199219 57.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.211765,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.352941%,82.352941%,82.352941%)",
      fillOpacity: 1
    },
    d: "M 98.601562 57.800781 C 98.601562 59.667969 98.601562 61.53125 98.601562 63.398438 C 99.667969 63.398438 100.734375 63.398438 101.800781 63.398438 C 100.683594 63.789062 99.484375 63.925781 98.199219 63.800781 C 98.070312 61.722656 98.207031 59.722656 98.601562 57.800781 Z M 98.601562 57.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.929412,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,47.45098%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 89.800781 65.398438 C 90.460938 66.160156 90.59375 66.960938 90.199219 67.800781 C 89.941406 67.027344 89.808594 66.226562 89.800781 65.398438 Z M 89.800781 65.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.607843,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.078431%,36.078431%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 113 74.199219 C 112.382812 73.878906 111.71875 73.746094 111 73.800781 C 111 74.199219 111 74.601562 111 75 C 111.53125 75 112.066406 75 112.601562 75 C 112.03125 75.378906 111.367188 75.511719 110.601562 75.398438 C 110.601562 74.734375 110.601562 74.066406 110.601562 73.398438 C 111.542969 73.335938 112.476562 73.402344 113.398438 73.601562 C 113.175781 73.753906 113.042969 73.953125 113 74.199219 Z M 113 74.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.67451,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface74",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,51.764706%,51.764706%)",
      fillOpacity: 1
    },
    d: "M 112.601562 76.601562 C 113.421875 76.820312 113.554688 77.222656 113 77.800781 C 112.976562 77.355469 112.84375 76.957031 112.601562 76.601562 Z M 112.601562 76.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface77",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.411765%,49.411765%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 112.601562 76.601562 C 112.066406 76.601562 111.53125 76.601562 111 76.601562 C 111 77 111 77.398438 111 77.800781 C 111.53125 77.800781 112.066406 77.800781 112.601562 77.800781 C 112.03125 78.179688 111.367188 78.3125 110.601562 78.199219 C 110.601562 77.53125 110.601562 76.867188 110.601562 76.199219 C 111.367188 76.085938 112.03125 76.21875 112.601562 76.601562 Z M 112.601562 76.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.784314,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface80",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.843137%,47.843137%,47.843137%)",
      fillOpacity: 1
    },
    d: "M 103 86.199219 C 102.46875 86.199219 102.199219 86.46875 102.199219 87 C 101.566406 86.546875 101.429688 86.011719 101.800781 85.398438 C 102.296875 85.578125 102.695312 85.84375 103 86.199219 Z M 103 86.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface83",
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,92.156863%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 89.800781 87 C 90.332031 87.265625 90.332031 87.265625 89.800781 87 Z M 89.800781 87 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface86",
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.764706%,31.764706%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 99 90.601562 C 99 90.867188 99.132812 91 99.398438 91 C 99.398438 91.132812 99.398438 91.265625 99.398438 91.398438 C 98.882812 91.304688 98.484375 91.4375 98.199219 91.800781 C 96.699219 90.902344 95.363281 89.769531 94.199219 88.398438 C 93.054688 87.839844 91.855469 87.441406 90.601562 87.199219 C 91.667969 86.933594 92.734375 86.933594 93.800781 87.199219 C 95.703125 88.109375 97.4375 89.242188 99 90.601562 Z M 99 90.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface89",
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.764706%,11.764706%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 107.800781 87.398438 C 115.875 87.421875 118.808594 91.289062 116.601562 99 C 117.746094 101.464844 117.414062 103.730469 115.601562 105.800781 C 115.40625 105.421875 115.339844 105.019531 115.398438 104.601562 C 115.347656 103.453125 114.8125 102.851562 113.800781 102.800781 C 114.808594 104.308594 114.808594 105.773438 113.800781 107.199219 C 114.101562 107.46875 114.234375 107.800781 114.199219 108.199219 C 113.210938 108.363281 112.675781 107.964844 112.601562 107 C 112.769531 105.0625 111.902344 103.996094 110 103.800781 C 109.25 104.019531 108.648438 104.421875 108.199219 105 C 107.933594 105 107.800781 105.132812 107.800781 105.398438 C 106.886719 105.871094 106.753906 106.539062 107.398438 107.398438 C 107.410156 110.710938 107.808594 113.976562 108.601562 117.199219 C 108.476562 118.695312 108.078125 120.09375 107.398438 121.398438 C 107.265625 121.398438 107.132812 121.398438 107 121.398438 C 107.0625 120.851562 106.996094 120.316406 106.800781 119.800781 C 106.613281 120.039062 106.546875 120.304688 106.601562 120.601562 C 106.238281 120.882812 106.105469 121.285156 106.199219 121.800781 C 105.613281 123.855469 104.414062 125.453125 102.601562 126.601562 C 102.265625 126.464844 102.132812 126.195312 102.199219 125.800781 C 102.199219 125.667969 102.199219 125.53125 102.199219 125.398438 C 102.609375 122.804688 102.476562 122.804688 101.800781 125.398438 C 101.800781 125.53125 101.800781 125.667969 101.800781 125.800781 C 101.53125 125.800781 101.398438 125.933594 101.398438 126.199219 C 100.46875 128.46875 98.867188 130.066406 96.601562 131 C 96.332031 131 96.199219 130.867188 96.199219 130.601562 C 96.199219 130.46875 96.199219 130.332031 96.199219 130.199219 C 96.703125 129.308594 96.703125 128.375 96.199219 127.398438 C 97.058594 127.445312 97.191406 127.175781 96.601562 126.601562 C 97.609375 126.074219 97.609375 125.605469 96.601562 125.199219 C 96.789062 124.472656 96.921875 123.605469 97 122.601562 C 96.601562 122.601562 96.199219 122.601562 95.800781 122.601562 C 95.800781 122.46875 95.800781 122.332031 95.800781 122.199219 C 95.933594 122.199219 96.066406 122.199219 96.199219 122.199219 C 96.75 121.644531 97.148438 120.976562 97.398438 120.199219 C 97.417969 119.585938 97.152344 119.183594 96.601562 119 C 96.46875 118.734375 96.332031 118.46875 96.199219 118.199219 C 96.335938 117.863281 96.601562 117.730469 97 117.800781 C 97.984375 117.90625 98.917969 118.171875 99.800781 118.601562 C 99.800781 118.867188 99.933594 119 100.199219 119 C 100.199219 119.265625 100.332031 119.398438 100.601562 119.398438 C 100.597656 120.125 100.796875 120.789062 101.199219 121.398438 C 101.832031 119.707031 101.367188 118.375 99.800781 117.398438 C 99.449219 117.453125 99.183594 117.320312 99 117 C 99.328125 116.644531 99.730469 116.511719 100.199219 116.601562 C 100.199219 115.933594 100.199219 115.265625 100.199219 114.601562 C 100.148438 114.304688 100.214844 114.039062 100.398438 113.800781 C 100.859375 114.273438 101.324219 114.273438 101.800781 113.800781 C 103.804688 114.003906 105.136719 113.203125 105.800781 111.398438 C 106.25 110.546875 106.320312 109.617188 106 108.601562 C 105.867188 108.867188 105.734375 109.132812 105.601562 109.398438 C 105.441406 109.308594 105.375 109.175781 105.398438 109 C 105.398438 108.199219 105.398438 107.398438 105.398438 106.601562 C 102.867188 106.601562 100.332031 106.601562 97.800781 106.601562 C 97.941406 109.058594 96.808594 110.523438 94.398438 111 C 92.175781 110.433594 90.972656 108.96875 90.800781 106.601562 C 90.667969 107.53125 90.53125 108.46875 90.398438 109.398438 C 90.253906 109.964844 89.917969 110.363281 89.398438 110.601562 C 88.996094 110.425781 88.996094 110.160156 89.398438 109.800781 C 87.078125 108.9375 86.414062 107.335938 87.398438 105 C 88.316406 104.566406 89.25 104.566406 90.199219 105 C 92.347656 103.664062 94.613281 103.464844 97 104.398438 C 99.53125 104.667969 102.066406 104.667969 104.601562 104.398438 C 104.164062 103.53125 103.632812 102.730469 103 102 C 103.238281 101.8125 103.503906 101.746094 103.800781 101.800781 C 105.421875 101.828125 107.023438 101.894531 108.601562 102 C 106.457031 101.34375 104.324219 100.878906 102.199219 100.601562 C 104.84375 97.511719 108.175781 96.578125 112.199219 97.800781 C 112.777344 98.246094 113.445312 98.3125 114.199219 98 C 113.902344 97.585938 113.503906 97.382812 113 97.398438 C 112.601562 97.398438 112.199219 97.398438 111.800781 97.398438 C 111.667969 96.277344 111.335938 95.207031 110.800781 94.199219 C 110.726562 94.996094 110.792969 95.796875 111 96.601562 C 108.886719 96.9375 106.753906 97.070312 104.601562 97 C 104.375 96.484375 103.976562 96.152344 103.398438 96 C 104.09375 95.257812 104.558594 95.324219 104.800781 96.199219 C 104.921875 95.875 105.125 95.609375 105.398438 95.398438 C 106.339844 95.265625 107.140625 95.464844 107.800781 96 C 108.757812 95.476562 108.757812 95.078125 107.800781 94.800781 C 108.066406 94.667969 108.332031 94.53125 108.601562 94.398438 C 108.023438 94.003906 107.625 93.46875 107.398438 92.800781 C 108.582031 92.4375 109.714844 91.972656 110.800781 91.398438 C 111.089844 90.753906 111.023438 90.15625 110.601562 89.601562 C 110.867188 89.46875 111.132812 89.332031 111.398438 89.199219 C 110.09375 88.753906 108.894531 88.152344 107.800781 87.398438 Z M 107.800781 87.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.482353,
      stroke: "none"
    }
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface92",
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.54902%,52.156863%,51.764706%)",
      fillOpacity: 1
    },
    d: "M 86.601562 90.199219 C 87.214844 89.683594 87.878906 89.683594 88.601562 90.199219 C 88.417969 90.519531 88.152344 90.652344 87.800781 90.601562 C 87.515625 90.238281 87.117188 90.105469 86.601562 90.199219 Z M 86.601562 90.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.717647,
      stroke: "none"
    }
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface95",
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.117647%,54.117647%,54.117647%)",
      fillOpacity: 1
    },
    d: "M 85.398438 89.800781 C 85.535156 90.136719 85.804688 90.269531 86.199219 90.199219 C 85.628906 90.613281 84.960938 90.882812 84.199219 91 C 84.199219 90.199219 84.601562 89.800781 85.398438 89.800781 Z M 85.398438 89.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.14902,
      stroke: "none"
    }
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface98",
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,86.666667%,86.27451%)",
      fillOpacity: 1
    },
    d: "M 84.199219 91 C 83.933594 91.265625 83.933594 91.265625 84.199219 91 Z M 84.199219 91 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.34902,
      stroke: "none"
    }
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface101",
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,63.921569%,62.745098%)",
      fillOpacity: 1
    },
    d: "M 110.199219 93.398438 C 109.699219 93.414062 109.296875 93.214844 109 92.800781 C 109.597656 92.566406 110 92.765625 110.199219 93.398438 Z M 110.199219 93.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface104",
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.196078%,9.803922%,9.411765%)",
      fillOpacity: 1
    },
    d: "M 103 86.199219 C 104.574219 86.703125 106.175781 87.101562 107.800781 87.398438 C 108.894531 88.152344 110.09375 88.753906 111.398438 89.199219 C 111.132812 89.332031 110.867188 89.46875 110.601562 89.601562 C 111.023438 90.15625 111.089844 90.753906 110.800781 91.398438 C 109.714844 91.972656 108.582031 92.4375 107.398438 92.800781 C 107.625 93.46875 108.023438 94.003906 108.601562 94.398438 C 108.332031 94.53125 108.066406 94.667969 107.800781 94.800781 C 108.757812 95.078125 108.757812 95.476562 107.800781 96 C 107.140625 95.464844 106.339844 95.265625 105.398438 95.398438 C 105.125 95.609375 104.921875 95.875 104.800781 96.199219 C 104.558594 95.324219 104.09375 95.257812 103.398438 96 C 103.976562 96.152344 104.375 96.484375 104.601562 97 C 101.824219 97.488281 99.023438 97.488281 96.199219 97 C 95.058594 97.027344 93.992188 97.292969 93 97.800781 C 92.703125 97.851562 92.4375 97.785156 92.199219 97.601562 C 93.808594 96.140625 93.675781 95.9375 91.800781 97 C 91.558594 96.949219 91.425781 96.816406 91.398438 96.601562 C 93.03125 95.546875 92.894531 95.214844 91 95.601562 C 91.398438 95.199219 91.800781 94.800781 92.199219 94.398438 C 91.433594 94.289062 90.902344 94.621094 90.601562 95.398438 C 89.988281 95.371094 89.589844 95.636719 89.398438 96.199219 C 89.398438 96.332031 89.398438 96.46875 89.398438 96.601562 C 89.132812 96.601562 89 96.734375 89 97 C 88.734375 97.132812 88.46875 97.265625 88.199219 97.398438 C 87.839844 97.117188 87.707031 96.714844 87.800781 96.199219 C 87.835938 95.320312 87.570312 95.1875 87 95.800781 C 86.246094 95.910156 85.714844 95.640625 85.398438 95 C 85.851562 94.347656 86.382812 93.75 87 93.199219 C 85.953125 93.371094 85.152344 93.972656 84.601562 95 C 84.601562 95.132812 84.601562 95.265625 84.601562 95.398438 C 84.332031 95.398438 84.199219 95.53125 84.199219 95.800781 C 83.636719 95.609375 83.371094 95.210938 83.398438 94.601562 C 84.363281 92.699219 85.832031 91.367188 87.800781 90.601562 C 88.152344 90.652344 88.417969 90.519531 88.601562 90.199219 C 87.878906 89.683594 87.214844 89.683594 86.601562 90.199219 C 86.46875 90.199219 86.332031 90.199219 86.199219 90.199219 C 85.804688 90.269531 85.535156 90.136719 85.398438 89.800781 C 86.972656 87.949219 88.972656 87.351562 91.398438 88 C 93.726562 88.863281 95.726562 90.195312 97.398438 92 C 97.773438 92.277344 98.042969 92.210938 98.199219 91.800781 C 98.484375 91.4375 98.882812 91.304688 99.398438 91.398438 C 99.53125 91.398438 99.667969 91.398438 99.800781 91.398438 C 99.925781 91.792969 100.191406 92.058594 100.601562 92.199219 C 100.734375 91.933594 100.867188 91.667969 101 91.398438 C 102.464844 91.929688 102.597656 91.664062 101.398438 90.601562 C 101.851562 90.257812 102.386719 90.257812 103 90.601562 C 103.851562 91.25 104.652344 91.984375 105.398438 92.800781 C 105.667969 93.066406 105.933594 93.066406 106.199219 92.800781 C 104.128906 91.335938 102.792969 89.402344 102.199219 87 C 102.199219 86.46875 102.46875 86.199219 103 86.199219 Z M 103 86.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.121569,
      stroke: "none"
    }
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface107",
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(76.470588%,76.078431%,75.294118%)",
      fillOpacity: 1
    },
    d: "M 106.601562 93 C 106.914062 93.113281 107.183594 93.3125 107.398438 93.601562 C 106.902344 93.894531 106.5 93.828125 106.199219 93.398438 C 106.46875 93.398438 106.601562 93.265625 106.601562 93 Z M 106.601562 93 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface110",
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.372549%,30.980392%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 99.398438 93 C 99.398438 92.867188 99.398438 92.734375 99.398438 92.601562 C 100.066406 92.601562 100.734375 92.601562 101.398438 92.601562 C 101.398438 93 101.398438 93.398438 101.398438 93.800781 C 101.132812 93.800781 101 93.933594 101 94.199219 C 100.601562 94.269531 100.335938 94.136719 100.199219 93.800781 C 99.804688 93.867188 99.535156 93.734375 99.398438 93.398438 C 99.933594 93.265625 99.933594 93.132812 99.398438 93 Z M 99.398438 93 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.537255,
      stroke: "none"
    }
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface113",
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.431373%,57.647059%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 100.199219 90.199219 C 100.199219 90.46875 100.332031 90.601562 100.601562 90.601562 C 100.734375 91.132812 100.867188 91.132812 101 90.601562 C 101.132812 90.601562 101.265625 90.601562 101.398438 90.601562 C 102.597656 91.664062 102.464844 91.929688 101 91.398438 C 100.867188 91.667969 100.734375 91.933594 100.601562 92.199219 C 100.191406 92.058594 99.925781 91.792969 99.800781 91.398438 C 99.800781 91.132812 99.667969 91 99.398438 91 C 99.132812 91 99 90.867188 99 90.601562 C 98.949219 90.304688 99.015625 90.039062 99.199219 89.800781 C 99.46875 90.101562 99.800781 90.234375 100.199219 90.199219 Z M 100.199219 90.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface116",
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(28.235294%,28.235294%,27.843137%)",
      fillOpacity: 1
    },
    d: "M 103 90.601562 C 102.386719 90.257812 101.851562 90.257812 101.398438 90.601562 C 101.265625 90.601562 101.132812 90.601562 101 90.601562 C 100.867188 90.601562 100.734375 90.601562 100.601562 90.601562 C 100.332031 90.601562 100.199219 90.46875 100.199219 90.199219 C 99.355469 89.175781 98.289062 88.441406 97 88 C 99.570312 87.589844 101.570312 88.457031 103 90.601562 Z M 103 90.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0352941,
      stroke: "none"
    }
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface119",
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.294118%,75.294118%,74.509804%)",
      fillOpacity: 1
    },
    d: "M 85.398438 95 C 85.265625 95 85.132812 95 85 95 C 84.867188 95 84.734375 95 84.601562 95 C 85.152344 93.972656 85.953125 93.371094 87 93.199219 C 86.382812 93.75 85.851562 94.347656 85.398438 95 Z M 85.398438 95 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface122",
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(55.686275%,55.294118%,54.117647%)",
      fillOpacity: 1
    },
    d: "M 101.398438 93.800781 C 102.582031 94.171875 103.78125 94.503906 105 94.800781 C 104.066406 95.066406 103.132812 95.066406 102.199219 94.800781 C 101.699219 94.632812 101.429688 94.300781 101.398438 93.800781 Z M 101.398438 93.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.211765,
      stroke: "none"
    }
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface125",
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(73.72549%,73.72549%,72.54902%)",
      fillOpacity: 1
    },
    d: "M 88.199219 95.398438 C 88.203125 94.527344 88.605469 94.191406 89.398438 94.398438 C 89.050781 94.816406 88.652344 95.152344 88.199219 95.398438 Z M 88.199219 95.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface128",
    clipPath: "url(#clip42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(39.215686%,39.215686%,39.215686%)",
      fillOpacity: 1
    },
    d: "M 83.398438 94.601562 C 83.371094 95.210938 83.636719 95.609375 84.199219 95.800781 C 84.46875 95.800781 84.601562 95.667969 84.601562 95.398438 C 84.867188 95.398438 85 95.265625 85 95 C 85.132812 95 85.265625 95 85.398438 95 C 85.714844 95.640625 86.246094 95.910156 87 95.800781 C 86.734375 96.332031 86.332031 96.734375 85.800781 97 C 85.683594 95.808594 85.148438 95.539062 84.199219 96.199219 C 83.933594 96.199219 83.800781 96.332031 83.800781 96.601562 C 83.464844 96.738281 83.332031 97.003906 83.398438 97.398438 C 83.066406 97.535156 82.929688 97.804688 83 98.199219 C 82.542969 98.839844 82.074219 99.507812 81.601562 100.199219 C 81.460938 98.082031 82.0625 96.214844 83.398438 94.601562 Z M 83.398438 94.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0470588,
      stroke: "none"
    }
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface131",
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.313725%,84.313725%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 90.601562 95.398438 C 90.46875 95.800781 90.199219 96.066406 89.800781 96.199219 C 89.667969 96.199219 89.53125 96.199219 89.398438 96.199219 C 89.589844 95.636719 89.988281 95.371094 90.601562 95.398438 Z M 90.601562 95.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface134",
    clipPath: "url(#clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(37.254902%,37.254902%,36.470588%)",
      fillOpacity: 1
    },
    d: "M 91.398438 96.601562 C 91.265625 96.066406 91.132812 96.066406 91 96.601562 C 90.734375 96.601562 90.601562 96.734375 90.601562 97 C 90.265625 97.136719 90.132812 97.402344 90.199219 97.800781 C 89.933594 97.800781 89.800781 97.933594 89.800781 98.199219 C 89.074219 98.847656 88.539062 99.648438 88.199219 100.601562 C 87.933594 100.601562 87.800781 100.46875 87.800781 100.199219 C 87.984375 99.039062 88.382812 97.972656 89 97 C 89.265625 97 89.398438 96.867188 89.398438 96.601562 C 89.667969 96.601562 89.800781 96.46875 89.800781 96.199219 C 90.199219 96.066406 90.46875 95.800781 90.601562 95.398438 C 90.902344 94.621094 91.433594 94.289062 92.199219 94.398438 C 91.800781 94.800781 91.398438 95.199219 91 95.601562 C 92.894531 95.214844 93.03125 95.546875 91.398438 96.601562 Z M 91.398438 96.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.717647,
      stroke: "none"
    }
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface137",
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.117647%,54.117647%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 93 97.800781 C 92.359375 98.238281 91.757812 98.773438 91.199219 99.398438 C 91.066406 99.132812 90.933594 98.867188 90.800781 98.601562 C 90.15625 99.4375 89.6875 100.371094 89.398438 101.398438 C 89.265625 101.332031 89.132812 101.265625 89 101.199219 C 89.421875 100.246094 89.6875 99.246094 89.800781 98.199219 C 90.066406 98.199219 90.199219 98.066406 90.199219 97.800781 C 90.535156 97.664062 90.667969 97.398438 90.601562 97 C 90.867188 97 91 96.867188 91 96.601562 C 91.132812 96.601562 91.265625 96.601562 91.398438 96.601562 C 91.425781 96.816406 91.558594 96.949219 91.800781 97 C 93.675781 95.9375 93.808594 96.140625 92.199219 97.601562 C 92.4375 97.785156 92.703125 97.851562 93 97.800781 Z M 93 97.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.462745,
      stroke: "none"
    }
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface140",
    clipPath: "url(#clip46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,57.254902%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 113 97.398438 C 113.503906 97.382812 113.902344 97.585938 114.199219 98 C 113.445312 98.3125 112.777344 98.246094 112.199219 97.800781 C 112.597656 97.867188 112.863281 97.734375 113 97.398438 Z M 113 97.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface143",
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,30.588235%,30.588235%)",
      fillOpacity: 1
    },
    d: "M 87.800781 96.199219 C 87.707031 96.714844 87.839844 97.117188 88.199219 97.398438 C 87.296875 98.804688 86.5 100.269531 85.800781 101.800781 C 85.667969 101.800781 85.53125 101.800781 85.398438 101.800781 C 85.554688 99.625 86.355469 97.757812 87.800781 96.199219 Z M 87.800781 96.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface146",
    clipPath: "url(#clip48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.098039%,25.098039%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 85.800781 97 C 84.332031 98.738281 83.398438 100.738281 83 103 C 82.621094 102.433594 82.488281 101.765625 82.601562 101 C 82.667969 100.054688 82.804688 99.121094 83 98.199219 C 83.335938 98.0625 83.46875 97.796875 83.398438 97.398438 C 83.734375 97.261719 83.867188 96.996094 83.800781 96.601562 C 84.066406 96.601562 84.199219 96.46875 84.199219 96.199219 C 85.148438 95.539062 85.683594 95.808594 85.800781 97 Z M 85.800781 97 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface149",
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,7.843137%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 77.800781 100.601562 C 77.800781 101.800781 77.800781 103 77.800781 104.199219 C 75.429688 104.078125 73.097656 104.210938 70.800781 104.601562 C 70.652344 104.964844 70.449219 105.300781 70.199219 105.601562 C 70.835938 105.945312 71.5 106.210938 72.199219 106.398438 C 71.625 107.320312 71.824219 108.054688 72.800781 108.601562 C 73.066406 109 73.066406 109.398438 72.800781 109.800781 C 72.296875 108.859375 71.632812 108.59375 70.800781 109 C 70.164062 108.78125 69.566406 108.515625 69 108.199219 C 67.542969 105.824219 66.078125 103.425781 64.601562 101 C 68.992188 100.601562 73.390625 100.46875 77.800781 100.601562 Z M 77.800781 100.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.239216,
      stroke: "none"
    }
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface152",
    clipPath: "url(#clip50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.45098%,66.666667%)",
      fillOpacity: 1
    },
    d: "M 102.199219 100.601562 C 104.324219 100.878906 106.457031 101.34375 108.601562 102 C 107.023438 101.894531 105.421875 101.828125 103.800781 101.800781 C 102.949219 101.472656 102.015625 101.273438 101 101.199219 C 101.296875 100.785156 101.699219 100.585938 102.199219 100.601562 Z M 102.199219 100.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.478431,
      stroke: "none"
    }
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface155",
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,67.45098%,67.45098%)",
      fillOpacity: 1
    },
    d: "M 85.398438 101.800781 C 85.53125 101.800781 85.667969 101.800781 85.800781 101.800781 C 85.660156 102.683594 85.328125 103.484375 84.800781 104.199219 C 84.75 103.328125 84.953125 102.527344 85.398438 101.800781 Z M 85.398438 101.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.266667,
      stroke: "none"
    }
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface158",
    clipPath: "url(#clip52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.156863%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 87.800781 100.199219 C 87.800781 100.46875 87.933594 100.601562 88.199219 100.601562 C 87.988281 101.570312 87.65625 102.503906 87.199219 103.398438 C 87.027344 102.230469 87.226562 101.164062 87.800781 100.199219 Z M 87.800781 100.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.729412,
      stroke: "none"
    }
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface161",
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(35.686275%,35.294118%,34.901961%)",
      fillOpacity: 1
    },
    d: "M 120.199219 100.601562 C 120.199219 101.800781 120.199219 103 120.199219 104.199219 C 122.878906 104.066406 125.546875 104.203125 128.199219 104.601562 C 128.152344 104.84375 128.015625 104.976562 127.800781 105 C 125.207031 104.605469 122.542969 104.46875 119.800781 104.601562 C 119.675781 103.183594 119.808594 101.851562 120.199219 100.601562 Z M 120.199219 100.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.27451,
      stroke: "none"
    }
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface164",
    clipPath: "url(#clip54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(66.666667%,66.666667%,66.666667%)",
      fillOpacity: 1
    },
    d: "M 82.601562 101 C 82.488281 101.765625 82.621094 102.433594 83 103 C 83.066406 103.941406 83 104.875 82.800781 105.800781 C 82.667969 105.667969 82.53125 105.53125 82.398438 105.398438 C 82.074219 103.855469 82.144531 102.390625 82.601562 101 Z M 82.601562 101 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.815686,
      stroke: "none"
    }
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface167",
    clipPath: "url(#clip55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.843137%,46.666667%,47.058824%)",
      fillOpacity: 1
    },
    d: "M 115.398438 104.601562 C 115.179688 105.859375 114.78125 107.058594 114.199219 108.199219 C 114.234375 107.800781 114.101562 107.46875 113.800781 107.199219 C 114.808594 105.773438 114.808594 104.308594 113.800781 102.800781 C 114.8125 102.851562 115.347656 103.453125 115.398438 104.601562 Z M 115.398438 104.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.776471,
      stroke: "none"
    }
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface170",
    clipPath: "url(#clip56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.901961%,54.901961%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 108.199219 105 C 108.417969 105.023438 108.550781 105.15625 108.601562 105.398438 C 108.121094 106.058594 107.722656 106.722656 107.398438 107.398438 C 106.753906 106.539062 106.886719 105.871094 107.800781 105.398438 C 108.066406 105.398438 108.199219 105.265625 108.199219 105 Z M 108.199219 105 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.423529,
      stroke: "none"
    }
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface173",
    clipPath: "url(#clip57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(61.568627%,61.568627%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 105.800781 111.398438 C 105.734375 109.90625 105.402344 109.90625 104.800781 111.398438 C 104.636719 110.488281 104.839844 109.691406 105.398438 109 C 105.375 109.175781 105.441406 109.308594 105.601562 109.398438 C 105.734375 109.132812 105.867188 108.867188 106 108.601562 C 106.320312 109.617188 106.25 110.546875 105.800781 111.398438 Z M 105.800781 111.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface176",
    clipPath: "url(#clip58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.176471%,21.176471%,21.176471%)",
      fillOpacity: 1
    },
    d: "M 112.601562 107 C 112.675781 107.964844 113.210938 108.363281 114.199219 108.199219 C 113.289062 110.171875 112.222656 112.039062 111 113.800781 C 110.636719 113.515625 110.503906 113.117188 110.601562 112.601562 C 110.957031 110.59375 111.625 108.726562 112.601562 107 Z M 112.601562 107 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface179",
    clipPath: "url(#clip59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.568627%,81.568627%,81.568627%)",
      fillOpacity: 1
    },
    d: "M 91 111.398438 C 91 111.53125 91 111.667969 91 111.800781 C 90.234375 111.914062 89.566406 111.78125 89 111.398438 C 89.667969 110.867188 90.332031 110.867188 91 111.398438 Z M 91 111.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface182",
    clipPath: "url(#clip60)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.72549%,33.72549%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 91 111.398438 C 92.28125 110.933594 92.949219 111.46875 93 113 C 92.351562 112.75 91.816406 112.351562 91.398438 111.800781 C 91.398438 111.53125 91.265625 111.398438 91 111.398438 Z M 91 111.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.356863,
      stroke: "none"
    }
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface185",
    clipPath: "url(#clip61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(74.509804%,74.509804%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 94.199219 113.398438 C 93.640625 113.925781 93.242188 113.792969 93 113 C 93.558594 112.472656 93.957031 112.609375 94.199219 113.398438 Z M 94.199219 113.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.470588,
      stroke: "none"
    }
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface188",
    clipPath: "url(#clip62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.137255%,63.137255%,63.137255%)",
      fillOpacity: 1
    },
    d: "M 101.800781 113.800781 C 101.324219 114.273438 100.859375 114.273438 100.398438 113.800781 C 100.214844 114.039062 100.148438 114.304688 100.199219 114.601562 C 99.558594 114.082031 99.359375 113.414062 99.601562 112.601562 C 100.289062 113.148438 101.019531 113.546875 101.800781 113.800781 Z M 101.800781 113.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.729412,
      stroke: "none"
    }
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface191",
    clipPath: "url(#clip63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,57.647059%,57.647059%)",
      fillOpacity: 1
    },
    d: "M 98.601562 115 C 98.652344 114.703125 98.585938 114.4375 98.398438 114.199219 C 97.882812 114.714844 97.417969 114.714844 97 114.199219 C 97.785156 114.167969 98.386719 113.636719 98.800781 112.601562 C 99.117188 113.484375 99.046875 114.285156 98.601562 115 Z M 98.601562 115 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.333333,
      stroke: "none"
    }
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface194",
    clipPath: "url(#clip64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.882353%,65.882353%,65.490196%)",
      fillOpacity: 1
    },
    d: "M 87.398438 114.199219 C 87.445312 114.445312 87.578125 114.648438 87.800781 114.800781 C 87.433594 114.910156 87.167969 115.109375 87 115.398438 C 85.867188 114.539062 86 114.140625 87.398438 114.199219 Z M 87.398438 114.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.403922,
      stroke: "none"
    }
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface197",
    clipPath: "url(#clip65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(66.27451%,66.27451%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 110.601562 112.601562 C 110.503906 113.117188 110.636719 113.515625 111 113.800781 C 111.074219 114.441406 110.875 114.976562 110.398438 115.398438 C 110.082031 114.382812 110.148438 113.453125 110.601562 112.601562 Z M 110.601562 112.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.113725,
      stroke: "none"
    }
  }))), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface200",
    clipPath: "url(#clip66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,67.843137%,66.666667%)",
      fillOpacity: 1
    },
    d: "M 97.800781 115.800781 C 97.441406 116.691406 96.773438 117.089844 95.800781 117 C 96.195312 116.238281 96.859375 115.835938 97.800781 115.800781 Z M 97.800781 115.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.247059,
      stroke: "none"
    }
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface203",
    clipPath: "url(#clip67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(83.137255%,82.352941%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 97 117.800781 C 96.601562 117.730469 96.335938 117.863281 96.199219 118.199219 C 96.066406 118.199219 95.933594 118.199219 95.800781 118.199219 C 95.753906 117.953125 95.621094 117.753906 95.398438 117.601562 C 96.027344 117.292969 96.558594 117.359375 97 117.800781 Z M 97 117.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.498039,
      stroke: "none"
    }
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface206",
    clipPath: "url(#clip68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.392157%,60.392157%,59.607843%)",
      fillOpacity: 1
    },
    d: "M 89.398438 117.398438 C 90.144531 117.9375 90.945312 118.335938 91.800781 118.601562 C 90.894531 118.457031 90.160156 118.722656 89.601562 119.398438 C 89.402344 118.746094 89.335938 118.078125 89.398438 117.398438 Z M 89.398438 117.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.52549,
      stroke: "none"
    }
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface209",
    clipPath: "url(#clip69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.137255%,62.745098%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 99.800781 117.398438 C 101.367188 118.375 101.832031 119.707031 101.199219 121.398438 C 100.796875 120.789062 100.597656 120.125 100.601562 119.398438 C 100.332031 119.398438 100.199219 119.265625 100.199219 119 C 99.933594 119 99.800781 118.867188 99.800781 118.601562 C 99.800781 118.199219 99.800781 117.800781 99.800781 117.398438 Z M 99.800781 117.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface212",
    clipPath: "url(#clip70)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.156863%,32.156863%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 95.800781 118.199219 C 95.933594 119 96.066406 119.800781 96.199219 120.601562 C 96.199219 120.867188 96.066406 121 95.800781 121 C 95.671875 120.378906 95.273438 120.113281 94.601562 120.199219 C 94.601562 120.066406 94.601562 119.933594 94.601562 119.800781 C 94.808594 119.113281 95.207031 118.578125 95.800781 118.199219 Z M 95.800781 118.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface215",
    clipPath: "url(#clip71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.588235%,10.196078%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 89 111.398438 C 89.566406 111.78125 90.234375 111.914062 91 111.800781 C 91.132812 111.800781 91.265625 111.800781 91.398438 111.800781 C 91.816406 112.351562 92.351562 112.75 93 113 C 93.242188 113.792969 93.640625 113.925781 94.199219 113.398438 C 95.082031 113.828125 96.015625 114.09375 97 114.199219 C 97.417969 114.714844 97.882812 114.714844 98.398438 114.199219 C 98.585938 114.4375 98.652344 114.703125 98.601562 115 C 98.46875 115.398438 98.199219 115.667969 97.800781 115.800781 C 96.859375 115.835938 96.195312 116.238281 95.800781 117 C 94.988281 117.066406 94.1875 116.996094 93.398438 116.800781 C 92.617188 116.148438 91.753906 115.679688 90.800781 115.398438 C 89.597656 115.496094 89.132812 116.164062 89.398438 117.398438 C 89.335938 118.078125 89.402344 118.746094 89.601562 119.398438 C 90.160156 118.722656 90.894531 118.457031 91.800781 118.601562 C 92.742188 119.0625 93.675781 119.464844 94.601562 119.800781 C 94.066406 119.933594 94.066406 120.066406 94.601562 120.199219 C 95.273438 120.113281 95.671875 120.378906 95.800781 121 C 95.800781 121.132812 95.800781 121.265625 95.800781 121.398438 C 95.800781 121.667969 95.800781 121.933594 95.800781 122.199219 C 95.265625 122.332031 95.265625 122.46875 95.800781 122.601562 C 96.199219 122.601562 96.601562 122.601562 97 122.601562 C 96.921875 123.605469 96.789062 124.472656 96.601562 125.199219 C 97.609375 125.605469 97.609375 126.074219 96.601562 126.601562 C 97.191406 127.175781 97.058594 127.445312 96.199219 127.398438 C 95.792969 127.863281 95.660156 128.664062 95.800781 129.800781 C 95.800781 129.933594 95.800781 130.066406 95.800781 130.199219 C 95.464844 130.335938 95.332031 130.601562 95.398438 131 C 94.960938 131.4375 94.425781 131.507812 93.800781 131.199219 C 93.054688 130.628906 92.253906 130.160156 91.398438 129.800781 C 91.46875 129.402344 91.335938 129.136719 91 129 C 91 128.867188 91 128.734375 91 128.601562 C 91.070312 128.203125 90.933594 127.9375 90.601562 127.800781 C 90.601562 127.667969 90.601562 127.53125 90.601562 127.398438 C 90.679688 124.230469 90.414062 124.027344 89.800781 126.800781 C 89.8125 127.226562 89.945312 127.5625 90.199219 127.800781 C 90.199219 128.066406 90.199219 128.332031 90.199219 128.601562 C 89.910156 129.019531 89.511719 129.289062 89 129.398438 C 87.570312 127.976562 87.167969 126.308594 87.800781 124.398438 C 85.914062 124.160156 85.914062 123.558594 87.800781 122.601562 C 88.15625 122.296875 88.421875 121.894531 88.601562 121.398438 C 88.460938 120.921875 88.261719 120.921875 88 121.398438 C 87.8125 121.164062 87.746094 120.894531 87.800781 120.601562 C 88.066406 119.40625 88.332031 118.207031 88.601562 117 C 88.226562 116.285156 87.691406 115.75 87 115.398438 C 87.167969 115.109375 87.433594 114.910156 87.800781 114.800781 C 87.578125 114.648438 87.445312 114.445312 87.398438 114.199219 C 87.796875 114.234375 88.132812 114.101562 88.398438 113.800781 C 88.441406 112.671875 88.640625 111.871094 89 111.398438 Z M 89 111.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface218",
    clipPath: "url(#clip72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.862745%,56.470588%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 96.601562 119 C 97.152344 119.183594 97.417969 119.585938 97.398438 120.199219 C 97.148438 120.976562 96.75 121.644531 96.199219 122.199219 C 96.269531 121.804688 96.136719 121.535156 95.800781 121.398438 C 95.800781 121.265625 95.800781 121.132812 95.800781 121 C 96.066406 121 96.199219 120.867188 96.199219 120.601562 C 96.574219 120.171875 96.707031 119.640625 96.601562 119 Z M 96.601562 119 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0588235,
      stroke: "none"
    }
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface221",
    clipPath: "url(#clip73)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.392157%,80.392157%,80%)",
      fillOpacity: 1
    },
    d: "M 106.601562 120.601562 C 106.53125 120.996094 106.664062 121.261719 107 121.398438 C 107.132812 121.398438 107.265625 121.398438 107.398438 121.398438 C 107.117188 121.761719 106.714844 121.894531 106.199219 121.800781 C 106.105469 121.285156 106.238281 120.882812 106.601562 120.601562 Z M 106.601562 120.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.843137,
      stroke: "none"
    }
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface224",
    clipPath: "url(#clip74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(43.921569%,43.921569%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 87.800781 120.601562 C 87.746094 120.894531 87.8125 121.164062 88 121.398438 C 88.261719 120.921875 88.460938 120.921875 88.601562 121.398438 C 88.421875 121.894531 88.15625 122.296875 87.800781 122.601562 C 87.296875 122.4375 86.761719 122.304688 86.199219 122.199219 C 86.886719 121.78125 87.417969 121.246094 87.800781 120.601562 Z M 87.800781 120.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.333333,
      stroke: "none"
    }
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface227",
    clipPath: "url(#clip75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.098039%,65.098039%,65.098039%)",
      fillOpacity: 1
    },
    d: "M 102.199219 125.398438 C 102.066406 125.398438 101.933594 125.398438 101.800781 125.398438 C 102.476562 122.804688 102.609375 122.804688 102.199219 125.398438 Z M 102.199219 125.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.823529,
      stroke: "none"
    }
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface230",
    clipPath: "url(#clip76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,51.764706%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 109.800781 125 C 109.828125 125.765625 110.230469 126.230469 111 126.398438 C 110.910156 126.558594 110.773438 126.625 110.601562 126.601562 C 109.886719 126.871094 109.21875 127.003906 108.601562 127 C 108.332031 127 108.199219 127.132812 108.199219 127.398438 C 107.691406 127.636719 107.292969 127.636719 107 127.398438 C 107.941406 126.589844 108.875 125.789062 109.800781 125 Z M 109.800781 125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface233",
    clipPath: "url(#clip77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.156863%,12.156863%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 113 121.800781 C 113.453125 122.949219 113.71875 124.148438 113.800781 125.398438 C 114.210938 126.230469 114.074219 127.03125 113.398438 127.800781 C 113.074219 127.429688 112.742188 127.027344 112.398438 126.601562 C 111.863281 127.632812 111.132812 127.898438 110.199219 127.398438 C 110.332031 127.132812 110.46875 126.867188 110.601562 126.601562 C 110.773438 126.625 110.910156 126.558594 111 126.398438 C 110.230469 126.230469 109.828125 125.765625 109.800781 125 C 109.800781 124.867188 109.800781 124.734375 109.800781 124.601562 C 110.066406 124.601562 110.199219 124.46875 110.199219 124.199219 C 110.8125 123.914062 111.34375 123.515625 111.800781 123 C 112.117188 122.554688 112.316406 122.023438 112.398438 121.398438 C 112.554688 121.621094 112.753906 121.753906 113 121.800781 Z M 113 121.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.678431,
      stroke: "none"
    }
  }))), _clipPath78 || (_clipPath78 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface236",
    clipPath: "url(#clip78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(39.607843%,38.823529%,38.039216%)",
      fillOpacity: 1
    },
    d: "M 90.601562 127.398438 C 90.332031 127.398438 90.199219 127.53125 90.199219 127.800781 C 89.945312 127.5625 89.8125 127.226562 89.800781 126.800781 C 90.414062 124.027344 90.679688 124.230469 90.601562 127.398438 Z M 90.601562 127.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask78"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath79 || (_clipPath79 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface239",
    clipPath: "url(#clip79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.980392%,30.588235%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 113.800781 125.398438 C 114.375 126.160156 115.039062 126.292969 115.800781 125.800781 C 115.78125 126.859375 115.378906 127.261719 114.601562 127 C 114.328125 127.296875 114.058594 127.5625 113.800781 127.800781 C 113.667969 127.800781 113.53125 127.800781 113.398438 127.800781 C 114.074219 127.03125 114.210938 126.230469 113.800781 125.398438 Z M 113.800781 125.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask79"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.529412,
      stroke: "none"
    }
  }))), _clipPath80 || (_clipPath80 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface242",
    clipPath: "url(#clip80)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.627451%,68.235294%,66.666667%)",
      fillOpacity: 1
    },
    d: "M 101.398438 126.199219 C 101.398438 125.933594 101.53125 125.800781 101.800781 125.800781 C 101.933594 125.800781 102.066406 125.800781 102.199219 125.800781 C 102.132812 126.195312 102.265625 126.464844 102.601562 126.601562 C 102.574219 126.816406 102.441406 126.949219 102.199219 127 C 101.925781 126.703125 101.660156 126.4375 101.398438 126.199219 Z M 101.398438 126.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask80"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath81 || (_clipPath81 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface245",
    clipPath: "url(#clip81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.431373%,38.431373%,38.039216%)",
      fillOpacity: 1
    },
    d: "M 113 121.800781 C 112.753906 121.753906 112.554688 121.621094 112.398438 121.398438 C 112.316406 122.023438 112.117188 122.554688 111.800781 123 C 111.90625 122.410156 111.773438 121.875 111.398438 121.398438 C 111.058594 122.382812 110.65625 123.316406 110.199219 124.199219 C 109.933594 124.199219 109.800781 124.332031 109.800781 124.601562 C 107.300781 126.351562 104.636719 127.882812 101.800781 129.199219 C 101.226562 130.351562 100.558594 131.417969 99.800781 132.398438 C 99.347656 132.699219 98.945312 132.632812 98.601562 132.199219 C 99.710938 130.851562 100.777344 129.453125 101.800781 128 C 104.859375 126.671875 107.589844 124.871094 110 122.601562 C 110.535156 119.820312 111.535156 119.550781 113 121.800781 Z M 113 121.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.290196,
      stroke: "none"
    }
  }))), _clipPath82 || (_clipPath82 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface248",
    clipPath: "url(#clip82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 90.199219 127.800781 C 90.332031 127.800781 90.46875 127.800781 90.601562 127.800781 C 90.933594 127.9375 91.070312 128.203125 91 128.601562 C 90.734375 128.601562 90.601562 128.734375 90.601562 129 C 90.332031 129 90.199219 128.867188 90.199219 128.601562 C 90.199219 128.332031 90.199219 128.066406 90.199219 127.800781 Z M 90.199219 127.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask82"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.317647,
      stroke: "none"
    }
  }))), _clipPath83 || (_clipPath83 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface251",
    clipPath: "url(#clip83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(69.803922%,69.803922%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 96.199219 127.398438 C 96.703125 128.375 96.703125 129.308594 96.199219 130.199219 C 96.199219 129.933594 96.066406 129.800781 95.800781 129.800781 C 95.660156 128.664062 95.792969 127.863281 96.199219 127.398438 Z M 96.199219 127.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask83"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.211765,
      stroke: "none"
    }
  }))), _clipPath84 || (_clipPath84 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface254",
    clipPath: "url(#clip84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.705882%,84.705882%,84.313725%)",
      fillOpacity: 1
    },
    d: "M 110.601562 126.601562 C 110.46875 126.867188 110.332031 127.132812 110.199219 127.398438 C 110.199219 127.800781 110.199219 128.199219 110.199219 128.601562 C 110.199219 128.734375 110.199219 128.867188 110.199219 129 C 109.4375 128.96875 108.96875 128.570312 108.800781 127.800781 C 107.929688 128.335938 107.726562 128.203125 108.199219 127.398438 C 108.46875 127.398438 108.601562 127.265625 108.601562 127 C 109.21875 127.003906 109.886719 126.871094 110.601562 126.601562 Z M 110.601562 126.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask84"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath85 || (_clipPath85 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface257",
    clipPath: "url(#clip85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.117647%,34.117647%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 90.199219 128.601562 C 90.199219 128.867188 90.332031 129 90.601562 129 C 90.734375 129 90.867188 129 91 129 C 90.929688 129.398438 91.066406 129.664062 91.398438 129.800781 C 91.609375 130.339844 91.679688 130.871094 91.601562 131.398438 C 90.660156 130.789062 89.792969 130.121094 89 129.398438 C 89.511719 129.289062 89.910156 129.019531 90.199219 128.601562 Z M 90.199219 128.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath86 || (_clipPath86 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface260",
    clipPath: "url(#clip86)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,30.196078%,29.411765%)",
      fillOpacity: 1
    },
    d: "M 104.601562 129 C 105.441406 128.613281 106.375 128.480469 107.398438 128.601562 C 107.859375 130.925781 107.859375 133.195312 107.398438 135.398438 C 107.703125 133.277344 107.304688 131.34375 106.199219 129.601562 C 106.332031 129.46875 106.46875 129.332031 106.601562 129.199219 C 105.945312 129.003906 105.28125 128.9375 104.601562 129 Z M 104.601562 129 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask86"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath87 || (_clipPath87 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface263",
    clipPath: "url(#clip87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(42.352941%,42.352941%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 113.398438 127.800781 C 113.398438 128.066406 113.53125 128.199219 113.800781 128.199219 C 113.867188 128.597656 113.734375 128.863281 113.398438 129 C 113.425781 128.824219 113.359375 128.691406 113.199219 128.601562 C 111.71875 130.214844 110.121094 131.679688 108.398438 133 C 108.617188 131.960938 109.21875 131.097656 110.199219 130.398438 C 109.933594 130.265625 109.667969 130.132812 109.398438 130 C 109.753906 129.71875 110.019531 129.382812 110.199219 129 C 110.734375 128.867188 110.734375 128.734375 110.199219 128.601562 C 110.199219 128.199219 110.199219 127.800781 110.199219 127.398438 C 111.132812 127.898438 111.863281 127.632812 112.398438 126.601562 C 112.742188 127.027344 113.074219 127.429688 113.398438 127.800781 Z M 113.398438 127.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask87"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath88 || (_clipPath88 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface266",
    clipPath: "url(#clip88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.882353%,25.490196%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 104.601562 129 C 104.160156 129.636719 104.425781 129.96875 105.398438 130 C 104.921875 130.4375 104.390625 130.769531 103.800781 131 C 103.800781 130.734375 103.667969 130.601562 103.398438 130.601562 C 103.132812 130.601562 103 130.734375 103 131 C 102.734375 131 102.601562 131.132812 102.601562 131.398438 C 102.332031 131.398438 102.199219 131.53125 102.199219 131.800781 C 101.449219 132.4375 101.117188 132.304688 101.199219 131.398438 C 102.070312 130.191406 103.203125 129.390625 104.601562 129 Z M 104.601562 129 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask88"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0823529,
      stroke: "none"
    }
  }))), _clipPath89 || (_clipPath89 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface269",
    clipPath: "url(#clip89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.960784%,81.960784%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 95.800781 130.199219 C 95.800781 130.46875 95.933594 130.601562 96.199219 130.601562 C 96.199219 130.867188 96.332031 131 96.601562 131 C 96.261719 131.449219 95.859375 131.449219 95.398438 131 C 95.332031 130.601562 95.464844 130.335938 95.800781 130.199219 Z M 95.800781 130.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask89"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.517647,
      stroke: "none"
    }
  }))), _clipPath90 || (_clipPath90 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface272",
    clipPath: "url(#clip90)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.529412%,63.137255%,62.352941%)",
      fillOpacity: 1
    },
    d: "M 103.398438 130.601562 C 103.667969 130.601562 103.800781 130.734375 103.800781 131 C 104.839844 131.585938 104.707031 131.988281 103.398438 132.199219 C 103.265625 131.667969 103.132812 131.667969 103 132.199219 C 103 132.46875 102.867188 132.601562 102.601562 132.601562 C 102.46875 132.601562 102.332031 132.601562 102.199219 132.601562 C 102.199219 132.332031 102.199219 132.066406 102.199219 131.800781 C 102.46875 131.800781 102.601562 131.667969 102.601562 131.398438 C 102.867188 131.398438 103 131.265625 103 131 C 103 130.734375 103.132812 130.601562 103.398438 130.601562 Z M 103.398438 130.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask90"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath91 || (_clipPath91 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface275",
    clipPath: "url(#clip91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.470588%,16.470588%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 102.199219 132.601562 C 102.332031 132.601562 102.46875 132.601562 102.601562 132.601562 C 103.117188 132.988281 103.117188 133.390625 102.601562 133.800781 C 102.921875 135.359375 103.589844 135.625 104.601562 134.601562 C 104.5625 135.1875 104.960938 135.65625 105.800781 136 C 105.667969 136.132812 105.53125 136.265625 105.398438 136.398438 C 105.917969 136.597656 106.449219 136.664062 107 136.601562 C 107.035156 137.199219 106.769531 137.597656 106.199219 137.800781 C 104.03125 136.71875 101.898438 135.648438 99.800781 134.601562 C 98.011719 135.960938 96.011719 137.027344 93.800781 137.800781 C 92.800781 135.945312 92.265625 133.945312 92.199219 131.800781 C 94.6875 131.953125 97.085938 132.488281 99.398438 133.398438 C 100.371094 133.246094 101.304688 132.980469 102.199219 132.601562 Z M 102.199219 132.601562 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,8.627451%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 43.398438 43.398438 C 46.734375 43.332031 50.070312 43.398438 53.398438 43.601562 C 54.375 43.910156 55.109375 44.507812 55.601562 45.398438 C 56.347656 48.613281 56.347656 51.8125 55.601562 55 C 55.300781 55.25 54.964844 55.449219 54.601562 55.601562 C 55.957031 57.046875 56.488281 58.777344 56.199219 60.800781 C 56.269531 62.8125 55.9375 64.746094 55.199219 66.601562 C 54.839844 67.082031 54.371094 67.414062 53.800781 67.601562 C 50.335938 67.800781 46.871094 67.867188 43.398438 67.800781 C 43.398438 59.667969 43.398438 51.53125 43.398438 43.398438 Z M 51.398438 47.800781 C 51.507812 49.707031 51.375 51.570312 51 53.398438 C 49.933594 53.398438 48.867188 53.398438 47.800781 53.398438 C 47.800781 51.53125 47.800781 49.667969 47.800781 47.800781 C 49 47.800781 50.199219 47.800781 51.398438 47.800781 Z M 51 57.800781 C 51.375 59.628906 51.507812 61.496094 51.398438 63.398438 C 50.199219 63.398438 49 63.398438 47.800781 63.398438 C 47.800781 61.53125 47.800781 59.667969 47.800781 57.800781 C 48.867188 57.800781 49.933594 57.800781 51 57.800781 Z M 51 57.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,8.235294%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 69.800781 45 C 69.769531 46.3125 70.035156 47.511719 70.601562 48.601562 C 70.980469 49.167969 71.113281 49.835938 71 50.601562 C 70.917969 51.796875 71.183594 52.863281 71.800781 53.800781 C 73.046875 58.394531 73.980469 63.058594 74.601562 67.800781 C 73.132812 67.800781 71.667969 67.800781 70.199219 67.800781 C 69.984375 66.191406 69.71875 64.589844 69.398438 63 C 67.667969 63 65.933594 63 64.199219 63 C 64.210938 64.59375 63.945312 66.125 63.398438 67.601562 C 61.9375 67.800781 60.472656 67.867188 59 67.800781 C 60.554688 59.847656 62.289062 51.980469 64.199219 44.199219 C 65.894531 43.824219 67.628906 43.691406 69.398438 43.800781 C 69.304688 44.316406 69.4375 44.714844 69.800781 45 Z M 66.601562 50.601562 C 66.867188 51 67.132812 51.398438 67.398438 51.800781 C 67.75 54.34375 68.148438 56.875 68.601562 59.398438 C 67.53125 59.398438 66.46875 59.398438 65.398438 59.398438 C 65.800781 56.46875 66.199219 53.535156 66.601562 50.601562 Z M 66.601562 50.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.490196%,5.490196%,5.490196%)",
      fillOpacity: 1
    },
    d: "M 88.199219 43.800781 C 89.40625 44.140625 90.140625 44.941406 90.398438 46.199219 C 90.667969 49.800781 90.667969 53.398438 90.398438 57 C 90.3125 57.953125 89.84375 58.617188 89 59 C 88.179688 59.222656 88.046875 59.621094 88.601562 60.199219 C 89.1875 61.878906 89.585938 63.613281 89.800781 65.398438 C 89.808594 66.226562 89.941406 67.027344 90.199219 67.800781 C 88.757812 67.914062 87.359375 67.78125 86 67.398438 C 85.210938 64.90625 84.609375 62.371094 84.199219 59.800781 C 83.53125 59.800781 82.867188 59.800781 82.199219 59.800781 C 82.199219 62.46875 82.199219 65.132812 82.199219 67.800781 C 80.867188 67.800781 79.53125 67.800781 78.199219 67.800781 C 78.199219 59.800781 78.199219 51.800781 78.199219 43.800781 C 81.53125 43.800781 84.867188 43.800781 88.199219 43.800781 Z M 85.800781 47.800781 C 86.332031 50.332031 86.332031 52.867188 85.800781 55.398438 C 84.601562 55.398438 83.398438 55.398438 82.199219 55.398438 C 82.199219 52.867188 82.199219 50.332031 82.199219 47.800781 C 83.398438 47.800781 84.601562 47.800781 85.800781 47.800781 Z M 85.800781 47.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,8.235294%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 105 44.199219 C 104.972656 44.8125 105.238281 45.210938 105.800781 45.398438 C 106.105469 45.707031 106.308594 46.105469 106.398438 46.601562 C 106.667969 49.132812 106.667969 51.667969 106.398438 54.199219 C 106.199219 54.933594 105.734375 55.398438 105 55.601562 C 105.089844 55.757812 105.226562 55.824219 105.398438 55.800781 C 105.371094 56.410156 105.636719 56.8125 106.199219 57 C 106.660156 59.460938 106.726562 61.996094 106.398438 64.601562 C 106.195312 65.613281 105.726562 66.480469 105 67.199219 C 101.308594 67.777344 97.574219 67.976562 93.800781 67.800781 C 93.734375 59.796875 93.800781 51.796875 94 43.800781 C 97.367188 43.339844 100.769531 43.273438 104.199219 43.601562 C 104.566406 43.710938 104.832031 43.910156 105 44.199219 Z M 101.800781 47.800781 C 102.3125 49.652344 102.3125 51.519531 101.800781 53.398438 C 100.734375 53.398438 99.667969 53.398438 98.601562 53.398438 C 98.601562 51.53125 98.601562 49.667969 98.601562 47.800781 C 99.667969 47.800781 100.734375 47.800781 101.800781 47.800781 Z M 98.601562 57.800781 C 99.53125 57.800781 100.46875 57.800781 101.398438 57.800781 C 101.53125 58.199219 101.800781 58.46875 102.199219 58.601562 C 102.304688 60.238281 102.171875 61.839844 101.800781 63.398438 C 100.734375 63.398438 99.667969 63.398438 98.601562 63.398438 C 98.601562 61.53125 98.601562 59.667969 98.601562 57.800781 Z M 98.601562 57.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.568627%,1.568627%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 121.800781 47.398438 C 119.132812 47.398438 116.46875 47.398438 113.800781 47.398438 C 113.800781 49.53125 113.800781 51.667969 113.800781 53.800781 C 115.933594 53.800781 118.066406 53.800781 120.199219 53.800781 C 120.734375 55 120.734375 56.199219 120.199219 57.398438 C 118.066406 57.398438 115.933594 57.398438 113.800781 57.398438 C 113.800781 59.53125 113.800781 61.667969 113.800781 63.800781 C 116.46875 63.800781 119.132812 63.800781 121.800781 63.800781 C 122.191406 65.050781 122.324219 66.382812 122.199219 67.800781 C 118.199219 67.800781 114.199219 67.800781 110.199219 67.800781 C 110.199219 59.800781 110.199219 51.800781 110.199219 43.800781 C 114.066406 43.800781 117.933594 43.800781 121.800781 43.800781 C 121.800781 45 121.800781 46.199219 121.800781 47.398438 Z M 121.800781 47.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,9.019608%,9.019608%)",
      fillOpacity: 1
    },
    d: "M 125.800781 43.398438 C 129.136719 43.332031 132.46875 43.398438 135.800781 43.601562 C 136.777344 43.910156 137.507812 44.507812 138 45.398438 C 138.902344 49.714844 138.769531 53.980469 137.601562 58.199219 C 137.132812 58.667969 136.667969 59.132812 136.199219 59.601562 C 137.085938 62.273438 137.75 65.007812 138.199219 67.800781 C 136.734375 67.800781 135.265625 67.800781 133.800781 67.800781 C 133.203125 65.40625 132.601562 63.007812 132 60.601562 C 131.582031 59.957031 130.980469 59.691406 130.199219 59.800781 C 130.265625 62.335938 130.199219 64.871094 130 67.398438 C 128.507812 67.785156 126.976562 67.917969 125.398438 67.800781 C 125.273438 59.636719 125.40625 51.503906 125.800781 43.398438 Z M 133.398438 47.800781 C 133.933594 50.332031 133.933594 52.867188 133.398438 55.398438 C 132.332031 55.398438 131.265625 55.398438 130.199219 55.398438 C 130.199219 52.867188 130.199219 50.332031 130.199219 47.800781 C 131.265625 47.800781 132.332031 47.800781 133.398438 47.800781 Z M 133.398438 47.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.45098%,7.45098%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 141.800781 43.398438 C 143.265625 43.398438 144.734375 43.398438 146.199219 43.398438 C 146.199219 51.53125 146.199219 59.667969 146.199219 67.800781 C 144.734375 67.800781 143.265625 67.800781 141.800781 67.800781 C 141.800781 59.667969 141.800781 51.53125 141.800781 43.398438 Z M 141.800781 43.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,8.627451%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 159.800781 44.199219 C 161.683594 52.023438 163.417969 59.890625 165 67.800781 C 163.527344 67.867188 162.0625 67.800781 160.601562 67.601562 C 160.167969 66.238281 159.832031 64.839844 159.601562 63.398438 C 157.867188 62.867188 156.132812 62.867188 154.398438 63.398438 C 154.113281 64.859375 153.914062 66.324219 153.800781 67.800781 C 152.179688 67.929688 150.578125 67.796875 149 67.398438 C 150.734375 59.65625 152.46875 51.921875 154.199219 44.199219 C 156.066406 43.667969 157.933594 43.667969 159.800781 44.199219 Z M 156.601562 51 C 156.867188 51 157.132812 51 157.398438 51 C 157.746094 53.808594 158.148438 56.605469 158.601562 59.398438 C 157.53125 59.398438 156.46875 59.398438 155.398438 59.398438 C 155.851562 56.605469 156.253906 53.808594 156.601562 51 Z M 156.601562 51 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.607843%,19.607843%,19.607843%)",
      fillOpacity: 1
    },
    d: "M 86.199219 72.199219 C 87.832031 72.015625 89.367188 72.285156 90.800781 73 C 90.972656 73.71875 90.707031 74.25 90 74.601562 C 88.261719 73.433594 86.996094 73.832031 86.199219 75.800781 C 86.46875 76.867188 87.132812 77.53125 88.199219 77.800781 C 89.355469 76.609375 90.289062 76.746094 91 78.199219 C 88.949219 80.3125 86.882812 80.3125 84.800781 78.199219 C 83.683594 75.761719 84.148438 73.761719 86.199219 72.199219 Z M 86.199219 72.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.196078%,10.196078%,10.196078%)",
      fillOpacity: 1
    },
    d: "M 93 72.199219 C 93.667969 72.199219 94.332031 72.199219 95 72.199219 C 95 74.066406 95 75.933594 95 77.800781 C 96.066406 77.800781 97.132812 77.800781 98.199219 77.800781 C 98.199219 78.332031 98.199219 78.867188 98.199219 79.398438 C 96.46875 79.398438 94.734375 79.398438 93 79.398438 C 93 77 93 74.601562 93 72.199219 Z M 93 72.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(14.901961%,14.901961%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 99.800781 72.199219 C 100.46875 72.199219 101.132812 72.199219 101.800781 72.199219 C 101.734375 73.804688 101.800781 75.40625 102 77 C 103.007812 78.128906 103.808594 77.996094 104.398438 76.601562 C 104.597656 75.140625 104.664062 73.671875 104.601562 72.199219 C 105.265625 72.199219 105.933594 72.199219 106.601562 72.199219 C 106.667969 74.070312 106.597656 75.9375 106.398438 77.800781 C 105.039062 79.78125 103.238281 80.246094 101 79.199219 C 100.519531 78.839844 100.1875 78.371094 100 77.800781 C 99.800781 75.9375 99.734375 74.070312 99.800781 72.199219 Z M 99.800781 72.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.72549%,13.72549%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 108.601562 72.199219 C 110.472656 72.132812 112.339844 72.199219 114.199219 72.398438 C 115.265625 73.46875 115.265625 74.53125 114.199219 75.601562 C 115.800781 76.800781 115.800781 78 114.199219 79.199219 C 112.339844 79.398438 110.472656 79.464844 108.601562 79.398438 C 108.601562 77 108.601562 74.601562 108.601562 72.199219 Z M 113 74.199219 C 112.867188 74.46875 112.734375 74.734375 112.601562 75 C 112.066406 75 111.53125 75 111 75 C 111 74.601562 111 74.199219 111 73.800781 C 111.71875 73.746094 112.382812 73.878906 113 74.199219 Z M 112.601562 76.601562 C 112.84375 76.957031 112.976562 77.355469 113 77.800781 C 112.867188 77.800781 112.734375 77.800781 112.601562 77.800781 C 112.066406 77.800781 111.53125 77.800781 111 77.800781 C 111 77.398438 111 77 111 76.601562 C 111.53125 76.601562 112.066406 76.601562 112.601562 76.601562 Z M 112.601562 76.601562 "
  }), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.784314%,0.784314%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 51.800781 75.398438 C 60.332031 75.398438 68.867188 75.398438 77.398438 75.398438 C 77.398438 75.933594 77.398438 76.46875 77.398438 77 C 68.867188 77 60.332031 77 51.800781 77 C 51.800781 76.46875 51.800781 75.933594 51.800781 75.398438 Z M 51.800781 75.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.745098%,2.745098%,2.745098%)",
      fillOpacity: 1
    },
    d: "M 121.398438 75.398438 C 130.066406 75.398438 138.734375 75.398438 147.398438 75.398438 C 147.398438 75.933594 147.398438 76.46875 147.398438 77 C 138.734375 77 130.066406 77 121.398438 77 C 121.398438 76.46875 121.398438 75.933594 121.398438 75.398438 Z M 121.398438 75.398438 "
  }), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface74",
    mask: "url(#mask23)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface77",
    mask: "url(#mask24)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface80",
    mask: "url(#mask25)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface83",
    mask: "url(#mask26)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface86",
    mask: "url(#mask27)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface89",
    mask: "url(#mask28)"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface92",
    mask: "url(#mask29)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface95",
    mask: "url(#mask30)"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface98",
    mask: "url(#mask31)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface101",
    mask: "url(#mask32)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface104",
    mask: "url(#mask33)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface107",
    mask: "url(#mask34)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface110",
    mask: "url(#mask35)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface113",
    mask: "url(#mask36)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface116",
    mask: "url(#mask37)"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface119",
    mask: "url(#mask38)"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface122",
    mask: "url(#mask39)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface125",
    mask: "url(#mask40)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface128",
    mask: "url(#mask41)"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface131",
    mask: "url(#mask42)"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface134",
    mask: "url(#mask43)"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface137",
    mask: "url(#mask44)"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface140",
    mask: "url(#mask45)"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface143",
    mask: "url(#mask46)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface146",
    mask: "url(#mask47)"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface149",
    mask: "url(#mask48)"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface152",
    mask: "url(#mask49)"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface155",
    mask: "url(#mask50)"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface158",
    mask: "url(#mask51)"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface161",
    mask: "url(#mask52)"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface164",
    mask: "url(#mask53)"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface167",
    mask: "url(#mask54)"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface170",
    mask: "url(#mask55)"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface173",
    mask: "url(#mask56)"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface176",
    mask: "url(#mask57)"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface179",
    mask: "url(#mask58)"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface182",
    mask: "url(#mask59)"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface185",
    mask: "url(#mask60)"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface188",
    mask: "url(#mask61)"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface191",
    mask: "url(#mask62)"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface194",
    mask: "url(#mask63)"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface197",
    mask: "url(#mask64)"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface200",
    mask: "url(#mask65)"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface203",
    mask: "url(#mask66)"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface206",
    mask: "url(#mask67)"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface209",
    mask: "url(#mask68)"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface212",
    mask: "url(#mask69)"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface215",
    mask: "url(#mask70)"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface218",
    mask: "url(#mask71)"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface221",
    mask: "url(#mask72)"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface224",
    mask: "url(#mask73)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.196078%,10.196078%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 120.199219 100.601562 C 125.140625 100.46875 130.074219 100.601562 135 101 C 126.195312 116.210938 117.394531 131.410156 108.601562 146.601562 C 108.199219 146.601562 107.800781 146.601562 107.398438 146.601562 C 107.488281 147.070312 107.355469 147.46875 107 147.800781 C 106.660156 147.390625 106.257812 147.058594 105.800781 146.800781 C 105.847656 146.085938 105.847656 145.351562 105.800781 144.601562 C 107.101562 144.035156 107.234375 143.367188 106.199219 142.601562 C 108.761719 138.164062 111.164062 133.632812 113.398438 129 C 113.734375 128.863281 113.867188 128.597656 113.800781 128.199219 C 113.800781 128.066406 113.800781 127.933594 113.800781 127.800781 C 114.058594 127.5625 114.328125 127.296875 114.601562 127 C 115.378906 127.261719 115.78125 126.859375 115.800781 125.800781 C 119.65625 118.753906 123.65625 111.820312 127.800781 105 C 128.015625 104.976562 128.152344 104.84375 128.199219 104.601562 C 125.546875 104.203125 122.878906 104.066406 120.199219 104.199219 C 120.199219 103 120.199219 101.800781 120.199219 100.601562 Z M 120.199219 100.601562 "
  }), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface227",
    mask: "url(#mask74)"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface230",
    mask: "url(#mask75)"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface233",
    mask: "url(#mask76)"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface236",
    mask: "url(#mask77)"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface239",
    mask: "url(#mask78)"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface242",
    mask: "url(#mask79)"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface245",
    mask: "url(#mask80)"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface248",
    mask: "url(#mask81)"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface251",
    mask: "url(#mask82)"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface254",
    mask: "url(#mask83)"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface257",
    mask: "url(#mask84)"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface260",
    mask: "url(#mask85)"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface263",
    mask: "url(#mask86)"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface266",
    mask: "url(#mask87)"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface269",
    mask: "url(#mask88)"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface272",
    mask: "url(#mask89)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,7.45098%,6.666667%)",
      fillOpacity: 1
    },
    d: "M 104.601562 129 C 105.28125 128.9375 105.945312 129.003906 106.601562 129.199219 C 106.46875 129.332031 106.332031 129.46875 106.199219 129.601562 C 107.304688 131.34375 107.703125 133.277344 107.398438 135.398438 C 107.496094 135.917969 107.363281 136.316406 107 136.601562 C 106.449219 136.664062 105.917969 136.597656 105.398438 136.398438 C 105.53125 136.265625 105.667969 136.132812 105.800781 136 C 104.960938 135.65625 104.5625 135.1875 104.601562 134.601562 C 103.589844 135.625 102.921875 135.359375 102.601562 133.800781 C 103.117188 133.390625 103.117188 132.988281 102.601562 132.601562 C 102.867188 132.601562 103 132.46875 103 132.199219 C 103.132812 132.199219 103.265625 132.199219 103.398438 132.199219 C 104.707031 131.988281 104.839844 131.585938 103.800781 131 C 104.390625 130.769531 104.921875 130.4375 105.398438 130 C 104.425781 129.96875 104.160156 129.636719 104.601562 129 Z M 104.601562 129 "
  }), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface275",
    mask: "url(#mask90)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.372549%,10.980392%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 77.800781 100.601562 C 78.191406 101.851562 78.324219 103.183594 78.199219 104.601562 C 76.0625 104.535156 73.929688 104.601562 71.800781 104.800781 C 81.082031 120.898438 90.414062 136.964844 99.800781 153 C 101.945312 149.507812 104.078125 146.042969 106.199219 142.601562 C 107.234375 143.367188 107.101562 144.035156 105.800781 144.601562 C 105.847656 145.351562 105.847656 146.085938 105.800781 146.800781 C 106.257812 147.058594 106.660156 147.390625 107 147.800781 C 107.355469 147.46875 107.488281 147.070312 107.398438 146.601562 C 107.800781 146.601562 108.199219 146.601562 108.601562 146.601562 C 105.796875 151.339844 103.0625 156.140625 100.398438 161 C 100.113281 161.378906 99.78125 161.445312 99.398438 161.199219 C 89.164062 143.570312 79.03125 125.90625 69 108.199219 C 69.566406 108.515625 70.164062 108.78125 70.800781 109 C 71.632812 108.59375 72.296875 108.859375 72.800781 109.800781 C 73.066406 109.398438 73.066406 109 72.800781 108.601562 C 71.824219 108.054688 71.625 107.320312 72.199219 106.398438 C 71.5 106.210938 70.835938 105.945312 70.199219 105.601562 C 70.449219 105.300781 70.652344 104.964844 70.800781 104.601562 C 73.097656 104.210938 75.429688 104.078125 77.800781 104.199219 C 77.800781 103 77.800781 101.800781 77.800781 100.601562 Z M 77.800781 100.601562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarberiaClubLogo1);
export default __webpack_public_path__ + "static/media/barberia-club-logo-1.74f104ad2fa722f393ebeda94f576c9b.svg";
export { ForwardRef as ReactComponent };